module.exports = __webpack_public_path__ + "img/bobedu_bobocoin.gm.5638eca.png";